import React from 'react'
import { Flex } from '@chakra-ui/react'
import { Tag } from 'entities/tag'
import { routes } from 'routes'
import { Heading } from 'components/Heading'
import { Tags } from 'components/tags/Tags'

export const TechStack = ({ tags }: { tags: Pick<Tag, 'id' | 'label' | 'slug'>[] }) => {
    return (
        <Flex direction="column" gridGap="12px">
            <Heading as="h2" size="sm">
                Tech stack
            </Heading>
            <Tags
                tags={tags}
                buildHref={({ slug }) => routes.jobsPresetSearch({ tech: { slug } })}
                // tag props
                variant="secondary"
                size="md"
            />
        </Flex>
    )
}
